import { observer, inject } from 'mobx-react';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import styled from '@emotion/styled';
import { Card } from '@blueprintjs/core';
import { Instance } from 'mobx-state-tree';

import { AuthenticationStore, LocaleStore } from '../../store';
import RequestList from './RequestList';
import { css } from 'emotion';

interface RequestTabProps extends WithTranslateProps {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  LocaleStore?: Instance<typeof LocaleStore>;
}

interface RequestTabState {}

@inject('AuthenticationStore', 'LocaleStore')
@observer
class RequestTab extends React.Component<RequestTabProps, RequestTabState> {
  render() {
    return (
      <Container>
        <Card className={CardStyle.toString()}>
          <RequestList />
        </Card>
      </Container>
    );
  }
}

export default withTranslate(RequestTab);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
  '& .ag-theme-balham': {
    width: '100%',
  },
});
